<template>
    <transition name="fade">
        <div v-if="active" class="modal-overlay" @click.self="close">
            <div class="modal-container">
                <div class="modal-header">
                    <span>Attachments Detail</span>
                    <button class="close-btn" @click="close">✕</button>
                </div>
                <div class="modal-body">
                    <div class="vx-row mb-3 mt-6" style="margin-left: 0%">
                        <table class="vs-table vs-table--tbody-table">
                            <template>
                                <tr class="tr-values vs-table--tr tr-table-state-null selected" v-bind:key="tr.NameFile" v-for="(tr, i) in fileAttachment">
                                    <td class="td vs-table--td">{{ tr.NameFile }}</td>
                                    <td>
                                        <img :src="urlFile(tr)" style="width: 100px; height: 100px; object-fit: cover;" class="max-w-sm" @click="openPreview(i)" alt="">
                                    </td>
                                    <td class="td vs-table--td">
                                        <vx-tooltip text="Download" v-if="tr.PathFile != ''">
                                            <vs-button 
                                                type="line" 
                                                icon-pack="feather" 
                                                icon="icon-download" 
                                                :disabled="!tr.PathFile"
                                                @click.stop="download(tr)"
                                            />
                                        </vx-tooltip>
                                    </td>
                                </tr>
                            </template>
                        </table>
                    </div>
                </div>
            </div>
            <vue-easy-lightbox :visible="visible" :imgs="images" :index="index" @hide="handleHide" />
        </div>
    </transition>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
    name: "CustomModal",
    components: {
        VueEasyLightbox
    },
    props: {
        active: {
            type: Boolean,
            default: false
        },
        fileAttachment: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            visible: false,
            images: [],
            index: 0
        }
    },
    mounted() {
        window.addEventListener('keydown', this.handleEsc)
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleEsc)
    },
    watch: {
        fileAttachment: {
            immediate: true,
            handler(val) {
                this.images = val.map(v => v.PathFile)
            }
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
        openPreview(index) {
            this.index = index
            this.visible = true
        },
        handleHide() {
            this.visible = false
        },
        download(tr) {
            const link = document.createElement('a')
            link.href = tr.PathFile
            link.download = tr.NameFile
            link.click()
        },
        handleEsc(e) {
            if (e.key === 'Escape') this.close()
        }
    },
    computed: {
        urlFile: () => {
            return (tr) => {
                return tr.File instanceof Blob ? URL.createObjectURL(tr.File) : tr.PathFile
            }
        }
    },
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.modal-container {
    background: white;
    border-radius: 10px;
    width: 600px;
    max-height: 80vh;
    overflow: auto;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
    transform: scale(1);
    transition: all 0.3s ease;
}

.fade-enter .modal-container {
    transform: scale(0.9);
    opacity: 0;
}

.fade-enter-to .modal-container {
    transform: scale(1);
    opacity: 1;
}

.fade-leave-active .modal-container {
    transform: scale(0.9);
    opacity: 0;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #eee;
    font-weight: bold;
}

.close-btn {
    border: none;
    background: transparent;
    font-size: 18px;
    cursor: pointer;
}

.modal-body {
    padding: 10px;
}

.preview-img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    cursor: pointer;
}
</style>